"use client";

import type { ReactNode } from "react";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { toast } from "sonner";

export function VideoCatalogEntry({
  href,
  locked,
  active,
  children,
}: {
  href: string;
  locked: boolean;
  active: boolean;
  children: ReactNode;
}) {
  const t = useTranslations("site.video");
  const className = `kechengmulu_episode flex-heng${active ? " on" : ""}`;

  if (locked) {
    return (
      <button
        type="button"
        className={className}
        onClick={() => toast.info(t("lockedHint"), { id: "video-purchase-required" })}
      >
        {children}
      </button>
    );
  }

  return (
    <Link href={href} className={className}>
      {children}
    </Link>
  );
}
